/* SEC-12: SweetAlert2 renders `title`, `html` and `footer` as HTML.
   - Merchant content (product title, vendor and description, the GWP metafield
     text) is rendered as HTML exactly as it always was, through
     stsPopupSafeHtml(): <script> and <iframe> are removed, and so is every on*
     attribute and every attribute whose value is a javascript: URL. All
     formatting tags stay, so a formatted description still looks formatted.
   - Storefront API values (variant titles) are escaped; a URL is used only
     when it is http(s) or a same-site path. */
function stsPopupEsc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function stsPopupUrl(u) {
  try { return /^https?:$/.test(new URL(u, location.origin).protocol) ? u : ''; } catch (e) { return ''; }
}
function stsPopupSafeHtml(html) {
  try {
    /* A leading <body> keeps a leading <style> in the body instead of the
       discarded head, so it survives as it did before. The parsed document is
       inert: nothing in it runs or loads while it is being cleaned. */
    var doc = new DOMParser().parseFromString('<body>' + String(html == null ? '' : html), 'text/html');
    doc.body.querySelectorAll('script, iframe').forEach(function (n) { n.parentNode.removeChild(n); });
    doc.body.querySelectorAll('*').forEach(function (el) {
      Array.prototype.slice.call(el.attributes).forEach(function (a) {
        var v = String(a.value).replace(/[\u0000-\u0020\u007f]+/g, '');
        if (/^on/i.test(a.name) || /javascript:/i.test(v)) el.removeAttribute(a.name);
      });
    });
    return doc.body.innerHTML;
  } catch (e) { return stsPopupEsc(html); }
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.view-options-button').forEach(function(button) {
    button.addEventListener('click', async function(event) {
      event.preventDefault();
      
      const productId = this.getAttribute('data-product-id');
      const productTitle = this.getAttribute('data-product-title');
      const productVendor = this.getAttribute('data-product-vendor');
      const productDescription = this.getAttribute('data-product-description');
      const productImage = this.getAttribute('data-product-image');
      const productUrl = this.getAttribute('data-product-url');
      
      console.log('Product ID:', productId);
      console.log('Product Title:', productTitle);
      console.log('Product Vendor:', productVendor);
      console.log('Product Description:', productDescription);
      console.log('Product Image:', productImage);
      console.log('Product URL:', productUrl);

      try {
        const productVariants = await fetchProductVariants(productId);
        const truncatedDescription = truncateDescription(productDescription, 150);
        
        Swal.fire({
          title: stsPopupSafeHtml(productTitle),
          html: `
            <div style="text-align: left;">
              <img src="${stsPopupEsc(stsPopupUrl(productImage))}" alt="${stsPopupEsc(productTitle)}" style="width: 100%; max-width: 200px; float: left; margin-right: 20px;">
              <div>
                <h4>${stsPopupSafeHtml(productVendor)}</h4>
                <p>${stsPopupSafeHtml(truncatedDescription)}</p>
                <a href="${stsPopupEsc(stsPopupUrl(productUrl))}">View Full Details</a>
              </div>
              <div style="clear: both;"></div>
              <div style="margin-top: 20px;">
                <label for="variant-select">Size</label>
                <select id="variant-select">${productVariants}</select>
              </div>
              <div style="margin-top: 20px;">
                <label for="quantity" style="display: block;">Quantity</label>
                <div style="display: flex; align-items: center; gap: 10px;">
                  <button id="decrease-quantity" style="padding: 5px 10px; margin-top: 0px; width: 10%;">-</button>
                  <input type="number" id="quantity" name="quantity" min="1" value="1" style="width: 50px; text-align: center;">
                  <button id="increase-quantity" style="padding: 5px 10px; margin-top: 0px; width: 10%;">+</button>
                </div>
              </div>
              <button id="add-to-cart" class="btn btn--primary" style="margin-top: 20px;">Add to Cart</button>
            </div>
          `,
          showConfirmButton: false
        });

        // Add event listeners for the increment and decrement buttons
        document.getElementById('decrease-quantity').addEventListener('click', function() {
          const quantityInput = document.getElementById('quantity');
          const currentQuantity = parseInt(quantityInput.value);
          if (currentQuantity > 1) {
            quantityInput.value = currentQuantity - 1;
          }
        });

        document.getElementById('increase-quantity').addEventListener('click', function() {
          const quantityInput = document.getElementById('quantity');
          quantityInput.value = parseInt(quantityInput.value) + 1;
        });

        document.getElementById('add-to-cart').addEventListener('click', function() {
          const variantId = document.getElementById('variant-select').value;
          const quantity = document.getElementById('quantity').value;
          addToCart(variantId, quantity).then(() => {
            Swal.close();
          });
        });
      } catch (error) {
        console.error('Error fetching product variants:', error);
        Swal.fire({
          title: 'Error',
          text: 'There was an error loading the product details. Please try again later.',
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }
    });
  });

  async function fetchProductVariants(productId) {
    const query = `
    {
      product(id: "gid://shopify/Product/${productId}") {
        variants(first: 100) {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }`;
    
    /* A9(b): from the shop metafield via layout/theme.liquid, not a literal. */
    const accessToken = window.stsStorefrontToken;
    if (!accessToken) throw new Error('Storefront token is not configured');
    const response = await fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': accessToken
      },
      body: query
    });

    if (!response.ok) {
      throw new Error(`GraphQL query failed: ${response.statusText}`);
    }

    const responseBody = await response.json();
    if (responseBody.errors) {
      throw new Error(`GraphQL query errors: ${responseBody.errors.map(e => e.message).join(', ')}`);
    }

    const variantsHtml = responseBody.data.product.variants.edges.map(edge => {
      const variantId = edge.node.id.split('/').pop(); // Extract numeric ID
      return `<option value="${stsPopupEsc(variantId)}">${stsPopupEsc(edge.node.title)}</option>`;
    }).join('');
    
    console.log('Product Variants HTML:', variantsHtml);
    return variantsHtml;
  }

  function truncateDescription(description, maxLength) {
    if (description.length <= maxLength) {
      return description;
    }
    return description.substring(0, maxLength) + '...';
  }

  async function addToCart(variantId, quantity) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    
    console.log('Adding to cart:', { variantId, quantity });

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error adding to cart: ${response.statusText}`);
    }

    const data = await response.json();
    console.log('Add to cart response:', data);
    // Automatically opens the cart drawer
  }
});

document.addEventListener('click', function(e) {
  if (e.target.matches('.free-gift-button')) {
    const button = e.target;
    const title = button.getAttribute('data-gwp-title');
    const description = button.getAttribute('data-gwp-description');
    const image = button.getAttribute('data-gwp-image');
    const disclaimer = button.getAttribute('data-gwp-disclaimer');
    
    let popupContent = `
      <div style="text-align: left;">
        ${stsPopupUrl(image) ? `<img src="${stsPopupEsc(image)}" alt="${stsPopupEsc(title)}" style="width: 100%; max-width: 200px; margin-bottom: 20px;">` : ''}
        <div>
          <p>${stsPopupSafeHtml(description)}</p>
          ${disclaimer ? `<p class="small">${stsPopupSafeHtml(disclaimer)}</p>` : ''}
        </div>
      </div>
    `;

    Swal.fire({
      title: stsPopupSafeHtml(title),
      html: popupContent,
      showConfirmButton: true,
      confirmButtonText: 'OK',
      customClass: {
        confirmButton: 'btn btn--primary'
      }
    });
  }
});